import React from 'react';
import { ContactSection } from '../components/ContactSection';
export function ContactPage() {
  return <div className="pt-28" data-id="element-845">
      <ContactSection data-id="element-846" />
    </div>;
}